// extracted by mini-css-extract-plugin
module.exports = {"headerImageFrame":"zI","headerImage":"zJ"};